module.exports = __webpack_public_path__ + "static/media/logo-kitdigital.cd5a1e37.png";